<template>
  <span>
    <el-button
      :disabled="disabled"
      type="text"
      size="small"
      @click="dialogVisibleReject = true"
    >
      不通过
    </el-button>
    <el-dialog
      title="审核不通过"
      :visible.sync="dialogVisibleReject"
      width="422px"
      :modal="false"
      :before-close="handleClose"
    >
      <div class="text-area">
        <el-input
          type="textarea"
          :autosize="{
            minRows: 5
          }"
          :maxlength="200"
          :show-word-limit="true"
          placeholder="请输入批注(您可以点击下方内容进行快捷回复)"
          v-model.trim="textarea"
        ></el-input>
      </div>
      <div class="select-area">
        <ol>
          <li>请选择快捷批注内容</li>
          <li
            class="select-text"
            v-for="(item, index) in textArray"
            :key="index"
            @click="textarea += item"
          >
            {{ index + 1 }}.{{ item }}
          </li>
        </ol>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="reject">确 定</el-button>
      </span>
    </el-dialog>
  </span>
</template>

<script>
export default {
  props: ['disabled'],
  data() {
    return {
      dialogVisibleReject: false,
      textarea: '',
      textArray: ['图片不清晰', '定位地点错误', '不符合任务要求']
    };
  },
  mounted() {},
  watch: {
    textarea: function(value) {
      if (value.length > 200) {
        this.textarea = this.textarea.slice(0, 199);
      }
    }
  },
  methods: {
    reject() {
      this.$emit('withdraw', this.textarea);
      this.textarea = '';
      this.dialogVisibleReject = false;
    },
    handleClose(done) {
      this.$confirm('是否取消审核？')
        .then(_ => {
          this.textarea = '';
          this.dialogVisibleReject = false;
          done();
        })
        .catch(_ => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.select-area {
  text-align: left;
  .select-text {
    margin-top: 23px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
  }
  .select-text:hover {
    background-color: #fff;
    cursor: pointer;
  }
  margin-top: 20px;
  width: 382px;
  padding: 20px;
  height: 199px;
  background: #f5f7fa;
  border-radius: 2px;
  opacity: 0.99;
}
</style>
